// extracted by mini-css-extract-plugin
export default {"container":"UploadOpcModal_container__L-Grc","uploadFilesHeader":"UploadOpcModal_uploadFilesHeader__kjw6t","content":"UploadOpcModal_content__gHAfU"};